import { render, staticRenderFns } from "./colorPallete.vue?vue&type=template&id=8f5bc684&scoped=true"
import script from "./colorPallete.vue?vue&type=script&lang=js"
export * from "./colorPallete.vue?vue&type=script&lang=js"
import style0 from "./colorPallete.vue?vue&type=style&index=0&id=8f5bc684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5bc684",
  null
  
)

export default component.exports